import NavIcon from "../components/nav-icon"
import BannerLeft from "../components/banner-left"
import WrapperDuan from "../components/duan/wrapper-duan"
const Projects = () => {
    return (
        <>
        <NavIcon/>
        <BannerLeft/>
        <WrapperDuan/>
        </>
    )
}

export default Projects